/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DGA Control API
 * Sistema de monitoreo de extracción de aguas según Resolución 1238 de la DGA (Dirección General de Aguas).
 *
 * ## Protocol-level errors
 *
 * Answered to a request that is no operation of this spec, so no operation declares them. Their `type` is in `ProblemTypeEnum`.
 *
 * - `405` `/problems/method-not-allowed`: the HTTP verb is not supported on that path.
 * - `404` `/problems/not-found`: the URL matched no route at all. Distinct from an endpoint own 404, which means the route exists and the record does not.
 * OpenAPI spec version: 2.0.0
 */

/**
 * * `valid` - Valid
 * * `expired` - Expired
 * * `converted` - Converted
 */
export type QuoteStatusEnum = typeof QuoteStatusEnum[keyof typeof QuoteStatusEnum];


export const QuoteStatusEnum = {
  valid: 'valid',
  expired: 'expired',
  converted: 'converted',
} as const;
